export const SALES_METRICS = [
	'netSalesTY',
	'netSalesLY',
	'netSalesYoY',
	'netSalesYoYPctChg',
	'unitsTY',
	'unitsLY',
	'unitsYoY',
	'unitsYoYPctChg',
	'aurTY',
	'aurLY',
	'aurYoY',
	'aurYoYPctChg',
	'netSalesTYChngRef',
	'netSalesTYChngPctRef',
	'unitsTYChngRef',
	'unitsTYChngPctRef',
	'aurTYChngRef',
	'aurTYChngPctRef',
	'wmNetSalesTYChngPctRef',
	'wmUnitsTYChngPctRef',
	'storeCntTYPos',
	'storeCntTYChngRef',
];

export const INVENTORY_METRICS = [
	'storeOnHandQtyTY',
	'storeOnHandQtyLY',
	'storeOnHandQtyYoY',
	'storeOnHandQtyYoYPctChg',
	'storeOnOrderQtyTY',
	'storeOnOrderQtyLY',
	'storeOnOrderQtyYoY',
	'storeOnOrderQtyYoYPctChg',
	'storeInTransitQtyTY',
	'storeInTransitQtyLY',
	'storeInTransitQtyYoY',
	'storeInTransitQtyYoYPctChg',
	'storeInWarehouseQtyTY',
	'storeInWarehouseQtyLY',
	'storeInWarehouseQtyYoY',
	'storeInWarehouseQtyYoYPctChg',
	'totalStoreInventoryTY',
	'totalStoreInventoryLY',
	'totalStoreInventoryYoY',
	'totalStoreInventoryYoYPctChg',
	'inStockPctTY',
	'inStockPctLY',
	'inStockYoYPctChg',
	'dollarStoreWkTY',
	'dollarStoreWkLY',
	'dollarStoreWkYoY',
	'dollarStoreWkYoYPctChg',
	'qtyStoreWkTY',
	'qtyStoreWkLY',
	'qtyStoreWkYoY',
	'qtyStoreWkYoYPctChg',
	'qtyStoreWkTYAvg',
	'qtyStoreWkTYChngRefAvg',
	'traitedStoresAvg',
	'traitedStoresChngRefAvg',
	'validStoreCntAvg',
	'validStoreCntChngRefAvg',
	'oosStoresAvg',
];

export const OPD_METRICS = [
	'ftprRate',
	'preSubRate',
	'postSubRate',
	'nilPikRate',
	'preSubQty',
	'nilPickQty',
	'totalOrderQty',
	'unitsYoYPctChg',
	'subQty',
	'wmNilPickRate',
];

export const topTilesSalesMetrics = [
	'netSalesTY',
	'netSalesTYChngRef',
	'netSalesTYChngPctRef',
	'wmNetSalesTYChngPctRef',
	'unitsTY',
	'unitsTYChngRef',
	'unitsTYChngPctRef',
	'wmUnitsTYChngPctRef',
];

export const topTilesOpdMetrics = ['nilPikRate', 'wmNilPickRate'];

export const replenishtInventoryMetrics = ['replInstkPercentageTY'];

export const replenishmentOPDMetrics = ['nilPikRate'];

export const replenishmentInventoryMetricsWithDimension = [
	'traitedStoresAvg',
	'replInstkPercentageTY',
	'inStockPctTYAvg',
	'wos',
];

export const replenishmentOPDMetricsWithDimension = [
	'nilPickQty',
	'nilPikRate',
];

export const podInventoryMetricsWithDimension = [
	'traitedStoresAvg',
	'traitedStoresChngRefAvg',
	'validStoreCntAvg',
	'validStoreCntChngRefAvg',
];

export const podSalesMetricsWithDimension = [
	'storeCntTYAvg',
	'storeCntTYChngRef',
];

export const pricingSalesMetricsWithDimension = [
	'aurTY',
	'aurTYChngRef',
	'aurTYChngPctRef',
	'unitsTY',
	'unitsTYChngPctRef',
];

export const APOLLO_CLIENT_CONFIG = {
	APP_ID: 'CHANNELPERFORMANCE_INSIGHTS',
	FEDERATED_METRIC_VALUES: 'FEDERATED_METRIC_VALUES',
	ANOMALY: 'ANOMALY',
};

export const ANOMALY_TABLE_SALES_METRICS = [
	'netSalesTY',
	'netSalesTYChngRef',
	'netSalesTYChngPctRef',
	'unitsTY',
	'unitsTYChngRef',
	'unitsTYChngPctRef',
];

export const HIERARCHY_LEVEL = {
	DEPARTMENT: 'DEPARTMENT',
	CATEGORY: 'CATGEORY',
	SUBCATEGORY: 'SUBCATGORY',
};

export const DIMENSION = {
	DEPARTMENT: 'omniDeptNbr',
	SUBCATEGORY: 'omniSubCatNbr',
	CATEGORY: 'omniCatNbr',
	WM_UPC_NUMBER: 'wmUpcNbr',
	WM_ITEM_NUMBER: 'wmItemNbr',
};

export const STATUS_CODE = {
	SUCCESS: 200,
};

export const REPLENISHMENT_THRESHOLD = ['95'];

export const ROOT_CAUSES = {
	INVENTORY_HEALTH: 'inventoryHealth',
	PRICING: 'pricing',
	ASSORTMENT: 'assortment',
	POD: 'pod',
};

export const CHANNEL = {
	STORE: 'STORE',
	OMNI: 'OMNI',
	ECOM: 'ECOM',
};

export const DIMENSION_ATTRIBUTE = 'DIMENSION';

export const CHANNEL_ATTRIBUTE = 'channel';

export const REPLENISHABLE_INSTOCK = 'replenishableInstock';

export const STORE_DRILL_DOWN_METRICS = [
	'dcNumber',
	'replInstkPercentageTY',
	'inStockYoYPctChg',
	'storeOnHandQtyTY',
	'storeOnHandQtyYoY',
	'storeOnHandQtyYoYPctChg',
	'storeOnOrderQtyTY',
	'storeOnOrderQtyYoY',
	'storeOnOrderQtyYoYPctChg',
	'storeInTransitQtyTY',
	'storeInTransitQtyYoY',
	'storeInTransitQtyYoYPctChg',
	'storeInWarehouseQtyTY',
	'storeInWarehouseQtyYoY',
	'storeInWarehouseQtyYoYPctChg',
	'dcOnHandTY',
	'dcOnHandYoY',
	'dcOnHandYoYPctChg',
	'unitsTY',
	'unitsYoY',
	'unitsYoYPctChg',
	'netSalesTY',
	'netSalesYoY',
	'netSalesYoYPctChg',
	'nilPikRate',
	'nilPickQty',
	'dcOnOrderTY',
	'dcOnOrderYoY',
	'dcOnOrderYoYPctChg',
	'qtyStoreWkTY',
	'qtyStoreWkYoY',
	'qtyStoreWkYoYPctChg',
	'dollarStoreWkTY',
	'dollarStoreWkYoY',
	'dollarStoreWkYoYPctChg',
];

export const STORE_DRILL_DOWN_SALES_METRICS = [
	'unitsTY',
	'unitsYoY',
	'unitsYoYPctChg',
	'netSalesTY',
	'netSalesYoY',
	'netSalesYoYPctChg',
];

export const STORE_DRILL_DOWN_INVENTORY_METRICS = [
	'replInstkPercentageTY',
	'inStockYoYPctChg',
	'storeOnHandQtyTY',
	'storeOnHandQtyYoY',
	'storeOnHandQtyYoYPctChg',
	'storeOnOrderQtyTY',
	'storeOnOrderQtyYoY',
	'storeOnOrderQtyYoYPctChg',
	'storeInTransitQtyTY',
	'storeInTransitQtyYoY',
	'storeInTransitQtyYoYPctChg',
	'storeInWarehouseQtyTY',
	'storeInWarehouseQtyYoY',
	'storeInWarehouseQtyYoYPctChg',
	'dcOnHandTY',
	'dcOnHandYoY',
	'dcOnHandYoYPct',
	'dcOnOrderTY',
	'dcOnOrderYoY',
	'dcOnOrderYoYPct',
	'qtyStoreWkTY',
	'qtyStoreWkYoY',
	'qtyStoreWkYoYPctChg',
	'dollarStoreWkTY',
	'dollarStoreWkYoY',
	'dollarStoreWkYoYPctChg',
];

export const STORE_DRILL_DOWN_OPD_METRICS = ['nilPikRate', 'nilPickQty'];

export const STORE_DRILL_DOWN_DIMENSION_METRICS = ['nbr', 'nm'];

export const FEDERATED_METRIC_VALUES_V1 = 'federatedMetricValuesV1';
